 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTAUTHORSNOTE from '@/components/Text/authorsnote'
 import TEXTCHAPTER_01 from '@/components/Text/Chapter_01'
 import TEXTCHAPTER_02 from '@/components/Text/Chapter_02'
 import TEXTCHAPTER_03 from '@/components/Text/Chapter_03'
 import TEXTCHAPTER_04 from '@/components/Text/Chapter_04'
 import TEXTCHAPTER_05 from '@/components/Text/Chapter_05'
 import TEXTCHAPTER_06 from '@/components/Text/Chapter_06'
 import TEXTCHAPTER_07 from '@/components/Text/Chapter_07'
 import TEXTCHAPTER_08 from '@/components/Text/Chapter_08'
 import TEXTCHAPTER_09 from '@/components/Text/Chapter_09'
 import TEXTCHAPTER_10 from '@/components/Text/Chapter_10'
 import TEXTCHAPTER_11 from '@/components/Text/Chapter_11'
 import TEXTCHAPTER_12 from '@/components/Text/Chapter_12'
 import TEXTCHAPTER_13 from '@/components/Text/Chapter_13'
 import TEXTCHAPTER_14 from '@/components/Text/Chapter_14'
 import TEXTCHAPTER_15 from '@/components/Text/Chapter_15'
 import TEXTCHAPTER_16 from '@/components/Text/Chapter_16'
 import TEXTCHAPTER_17 from '@/components/Text/Chapter_17'
 import LOVE_2 from '@/components/love_2'
 import TEXTPHOTOGRAPHS from '@/components/Text/photographs'
 import TEXTACK from '@/components/Text/Ack'
 import TEXTCTA from '@/components/Text/CTA'
 import TEXTKEVINSULLIVAN_BUNDYBOOKS_V1 from '@/components/Text/KevinSullivan_BundyBooks_v1'
 import TEXTKEVINSULLIVAN_OTHERBOOKS_V1 from '@/components/Text/KevinSullivan_OtherBooks_v1'
 import TEXTRAILROADED_EXCERPT from '@/components/Text/RAILROADED_Excerpt'
 import TEXTSOFTVOICE_EXCERPT from '@/components/Text/SOFTVOICE_Excerpt'
 import TEXTTRUECRIMEADPAGE4 from '@/components/Text/TrueCrime-AdPage4'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/authorsnote",
 			"name" : "Text/authorsnote",
 			"component" : TEXTAUTHORSNOTE
 		},
 		{
 			"path" : "/Text/Chapter_01",
 			"name" : "Text/Chapter_01",
 			"component" : TEXTCHAPTER_01
 		},
 		{
 			"path" : "/Text/Chapter_02",
 			"name" : "Text/Chapter_02",
 			"component" : TEXTCHAPTER_02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js